import React, { createContext, useContext } from "react";
import { X } from "lucide-react";

export const DrawerCtx = createContext(null);
export const useDrawer = () => useContext(DrawerCtx);

export default function RightDrawer() {
  const { drawer, closeDrawer } = useDrawer();
  if (!drawer.open || !drawer.data) return null;
  const { data } = drawer;
  return (
    <aside className="w-[420px] bg-white border-l border-[var(--border-subtle)] flex flex-col shrink-0" data-testid="right-drawer">
      <div className="h-14 border-b border-[var(--border-subtle)] flex items-center justify-between px-4">
        <div className="text-xs uppercase tracking-widest text-zinc-500">{drawer.kind}</div>
        <button data-testid="drawer-close" onClick={closeDrawer} className="p-1.5 rounded-md hover:bg-zinc-100">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto scroll-thin">
        {typeof data === "function" ? data() : data}
      </div>
    </aside>
  );
}
